import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TableEditingActionsTypes } from 'src/app/components/shared/sharedModules/designSystem/models/tableEditingActionsTypes.enum';
import { TableRowEditor } from 'src/app/components/shared/sharedModules/designSystem/mu-table/mu-table.component';
import { StorageService } from 'src/app/components/shared/sharedServices/storage.service';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { Filters } from 'src/app/components/shared/types/filters.type';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { ProcessingData } from 'src/app/components/shared/types/processingData.type';
import { MU_ROW_INDEX, TableColumn } from 'src/app/components/shared/types/tableColumn.type';
import { environment } from 'src/environments/environment';
import { MassiveService } from '../../massive.service';
import { ServiceDataList } from '../../models/serviceDataList.model';
import { Service } from '../../models/services.model';
import { MassiveServiceFlags } from './massive-services.flags';
import { TableOption } from '../../models/tableOption.interface';
import { DeliveriesFilters } from '../../models/deliveriesFilters.model';
import { AssignFilterColumns } from 'src/app/components/users/models/interface/assignFilterColumns.enum';
import { DeliveriesFilterColumns } from '../../models/deliveriesFilterColumns.enum';
import { FilterMode } from 'src/app/components/shared/models/interface/filtersMode.enum';
import { FilterField } from 'src/app/components/shared/types/filterField.type';
import { ItemNumberToFilterShared } from 'src/app/components/shared/models/interface/itemNumberToFilter.interface';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { fileFormatsAllowedToUpload } from '../../models/filesFormatAllowedToUpload';
import { v4 as uuidv4 } from 'uuid';
import { MassiveDeliveryServiceNewClient } from 'src/app/components/shared/api/gen_api_client/RoutingServiceClientPb';
import { CreateMassiveDeliveryNewRequest } from 'src/app/components/shared/api/gen_api_client/routing_pb';
import { GrpcFactoryService } from 'src/app/components/shared/sharedServices/grpc-factory.service';
import { FlagChangedValue } from 'src/app/components/shared/models/interface/flagChangedValue.interface';
import { TranslateService } from '@ngx-translate/core';
import { Company, Country } from 'src/app/components/shared/models/interface/parametrizacion.interface';
import { CityShared } from '../../../shared/models/interface/cityShared.interface';
import { MuRouteDeliveriesData } from 'src/app/components/shared/models/interface/muRouteDeliveriesData.interface';
import { ClientPointCompany } from 'src/app/components/massive/models/clientPointCompany.interface';
import { MapElementShared } from 'src/app/components/shared/models/interface/mapElement.interface';
import { MarkerOptionPositionShared } from 'src/app/components/shared/models/interface/markerOptionPosition.interface';
import { sameNextDayConstants } from 'src/app/components/same-next-day/same-next-day.constants';

@Component({
  selector: 'app-deliveries',
  templateUrl: './deliveries.component.html',
  styleUrls: ['./deliveries.component.sass'],
})
export class DeliveriesComponent extends MuComponent {
  /**
   * This flag tells us if the request is already routed
   */
  routed: boolean;
  /**
   * the request id
   */
  requestId: number;
  /**
   * the flags to route the request
   */
  flags = new Flags<MassiveServiceFlags>();
  /**
   * the services of the table
   */
  deliveriesFilters = new Filters<DeliveriesFilters>(
    {
      storage: this.storageService,
      key: 'massive.services',
      data: { page: 1, limit: 25 },
      delay: 500,
      mode: FilterMode.MULTIPLE_FILTER,
      transform: data => {
        if (data.startDate) {
          data.startDate = new Date(data.startDate as unknown as string);
        }
        if (data.dueDate) {
          data.dueDate = new Date(data.dueDate as unknown as string);
        }
        return data;
      },
    },
    'page',
    'limit'
  );
  /**
   * the filters of the table
   */
  deliveriesFilterFields: FilterField<DeliveriesFilters>[] = [];
  /**
   * The services data
   */
  deliveriesDataList: ServiceDataList;
  /**
   * Backup for the services data
   */
   initialValuesDeliveriesDataList: any[];
  /**
   * edit table action
   */
  deliveriesActions = new Actions<TableEditingActionsTypes, TableRowEditor<Service>>();
  /**
   * columns definition of the table
   */
  deliveriesTableColumns: TableColumn<Service, DeliveriesFilters>[] = [];
  /**
   * The row options
   */
  tableOptionList: TableOption[] = [];
  /**
   * Loading excel info
   */
  processingRoute: ProcessingData<MassiveServiceFlags>;
  /**
   * Service markers
   */
  markers: MapElementShared[];

  errorMessage: string;
  breadCrumbItems: string[];
  filterColumns = AssignFilterColumns;
  formData: UntypedFormGroup;
  localityList: ItemNumberToFilterShared[] = [];
  sizeList: ItemNumberToFilterShared[] = [];
  fileFormData: UntypedFormGroup;
  massiveServiceFlags = MassiveServiceFlags;
  fileFormatsAllowedToUpload = fileFormatsAllowedToUpload.toString();
  fileLoaded = false;
  mdClient: MassiveDeliveryServiceNewClient;
  selectedCountry: Country;
  selectedCompany: Company;
  selectedCedi: ClientPointCompany;
  selectedCity: CityShared;
  idsServicesSelection: string[];

  constructor(
    private storageService: StorageService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private massiveService: MassiveService,
    private grpcFactoryService: GrpcFactoryService,
    private translateService: TranslateService
  ) {
    super();
    const stateExtras = this.router.getCurrentNavigation()?.extras?.state;
    if ( !stateExtras ) {
      this.router.navigate(['/masivos/new-routing']);
    } else {
      this.breadCrumbItems = stateExtras.breadcrumb?.split(',');
      this.selectedCountry = stateExtras.country;
      this.selectedCompany = stateExtras.company;
      this.selectedCedi = stateExtras.cedi;
      this.selectedCity = stateExtras.city;
    }
  }

  muOnInit(): void {
    this.mdClient = this.grpcFactoryService.create(
      MassiveDeliveryServiceNewClient,
      environment.hostnameMassive,
      'MassiveDeliveryServiceNewClient'
    );
    this.processingRoute = new ProcessingData<MassiveServiceFlags>({
      flags: this.flags,
      errorFlag: MassiveServiceFlags.ROUTING_FAIL,
      showFlag: MassiveServiceFlags.ROUTING_PACKAGES,
      title: 'context.massive.routePackages.title',
      message: 'context.massive.routePackages.message',
      errorTitle: 'context.massive.routePackages.errorTitle',
    });
    this.tableOptionList = [
      {
        actionType: TableEditingActionsTypes.START_ROW_EDITING,
        icon: 'edit',
      },
    ];
    this.deliveriesTableColumns = [
      new TableColumn({
        key: DeliveriesFilterColumns.CHECKBOX,
        filter: DeliveriesFilterColumns.CHECKBOX,
        className: 'mu-masivos-srv-tbl-col-1',
        getValue: this.getRowIndex.bind(this),
      }),
      new TableColumn({
        key: MU_ROW_INDEX,
        className: 'mu-masivos-srv-tbl-col-1',
        getValue: this.getRowIndex.bind(this),
      }),
      new TableColumn({
        key: 'idClient',
        className: 'mu-masivos-srv-tbl-col-2',
        editable: true,
      }),
      new TableColumn({
        key: 'clientName',
        className: 'mu-masivos-srv-tbl-col-2',
        editable: true,
      }),
      new TableColumn({
        key: 'address',
        className: 'mu-masivos-srv-tbl-col-3',
        editable: true,
      }),
      new TableColumn({
        key: 'lat',
        className: 'mu-masivos-srv-tbl-col-2',
        editable: true,
        getValue: this.getLatLng.bind(this),
      }),
      new TableColumn({
        label: 'options',
        className: 'mu-masivos-srv-tbl-col-2',
      }),
      new TableColumn({
        key: 'weight',
        className: 'mu-masivos-srv-tbl-col-1 mu-masivos-srv-tbl-col-weight',
      }),
      new TableColumn({
        key: 'phone',
        className: 'mu-masivos-srv-tbl-col-3',
      }),
      new TableColumn({
        key: 'size',
        className: 'mu-masivos-srv-tbl-col-1',
      }),
      new TableColumn({
        key: 'received',
        className: 'mu-masivos-srv-tbl-col-2',
      }),
      new TableColumn({
        key: 'createdDate',
        className: 'mu-masivos-srv-tbl-col-2',
      }),
      new TableColumn({
        key: 'deliveryDate',
        className: 'mu-masivos-srv-tbl-col-2',
      }),
      new TableColumn({
        key: 'locality',
        className: 'mu-masivos-srv-tbl-col-2',
      }),
    ];
    this.deliveriesFilterFields = [
      new FilterField({
        filter: 'orderId',
        getTooltip: this.getOrderIdFilterTooltip.bind(this),
      }),
      new FilterField({
        filter: 'idLocalities',
        optionsLength: 0,
        getLabel: this.getLocalityLabel.bind(this),
        getTooltip: this.getLocalityTooltip.bind(this),
      }),
      new FilterField({
        filter: 'idSizes',
        optionsLength: 0,
        getLabel: this.getSizeLabel.bind(this),
        getTooltip: this.getSizeTooltip.bind(this),
      }),
      new FilterField({
        filter: 'startDate',
        getLabel: this.getLabelStartDate.bind(this),
        getTooltip: this.getStartDateFilterTooltip.bind(this),
      }),
      new FilterField({
        filter: 'dueDate',
        getLabel: this.getLabelDueDate.bind(this),
        getTooltip: this.getDueDateFilterTooltip.bind(this),
      }),
    ];
    this.watchFields();
    this.deliveriesFilters.reset();
    this.deliveriesFilters.emitFilterChanges();
    this.initFileForm();
  }

  /**
   * get order Id tooltip
   *
   * @param {Date} startDate
   * @param {DeliveriesFilters} filters
   */
  getOrderIdFilterTooltip(id: string, filters: DeliveriesFilters): string {
    if (id || filters?.startDate) {
      return this.translateService.instant('form.label.filterToolbar.orderId');
    }
    return null;
  }

  /**
   * get label for start date
   *
   * @param {Date} startDate
   * @param {DeliveriesFilters} filters
   */
  getLabelStartDate(startDate: Date, filters: DeliveriesFilters) {
    if (startDate) {
      return `${startDate.getFullYear()}-${(startDate.getMonth() + 1)}-${(startDate.getDate())}`;
    } else if (filters?.startDate) {
      return `${filters.startDate.getFullYear()}-${(filters.startDate.getMonth() + 1)}-${(filters.startDate.getDate())}`;
    } else {
      return null;
    }
  }

  /**
   * get The start date tooltip
   *
   * @param {Date} startDate
   * @param {DeliveriesFilters} filters
   */
  getStartDateFilterTooltip(startDate: Date, filters: DeliveriesFilters): string {
    if (startDate || filters?.startDate) {
      return this.translateService.instant('form.label.filterToolbar.startDate');
    }
    return null;
  }

  /**
   * get label for due date
   *
   * @param {Date} dueDate
   * @param {PackageFilters} filters
   */
  getLabelDueDate(dueDate: Date, filters: DeliveriesFilters) {
    if (dueDate) {
      return `${dueDate.getFullYear()}-${(dueDate.getMonth() + 1)}-${(dueDate.getDate())}`;
    } else if (filters?.dueDate) {
      return `${filters.dueDate.getFullYear()}-${(filters.dueDate.getMonth() + 1)}-${(filters.dueDate.getDate())}`;
    } else {
      return null;
    }
  }

  /**
   * get The due date tooltip
   *
   * @param {Date} dueDate
   * @param {DeliveriesFilters} filters
   */
  getDueDateFilterTooltip(dueDate: Date, filters: DeliveriesFilters): string {
    if (dueDate || filters?.dueDate) {
      return this.translateService.instant('form.label.filterToolbar.dueDate');
    }
    return null;
  }

  /**
   * Method to get locality label
   *
   * @param {number} localityId
   */
  getLocalityLabel(localityId: number): string {
    return this.localityList?.find(x => x.value === localityId)?.label;
  }

  /**
   * Method to get locality tooltip
   *
   * @param {number} localityId
   */
  getLocalityTooltip(localityId: number, filters: DeliveriesFilters): string {
    let localities = [];
    filters?.idLocalities?.forEach( id => {
      localities.push( this.getLocalityLabel( parseInt(id) ) );
    });
    return localities.join(' , ');
  }

  /**
   * Method to get size label
   *
   * @param {number} sizeId
   */
  getSizeLabel(sizeId: number): string {    
    return this.sizeList?.find(x => x.value === sizeId)?.label;
  }

  /**
   * Method to get size tooltip
   *
   * @param {number} localityId
   */
  getSizeTooltip(sizeId: number, filters: DeliveriesFilters): string {
    let sizes = [];
    filters?.idSizes?.forEach( id => {
      sizes.push( this.getSizeLabel(id) );
    });
    return sizes.join(' , ');
  }

  /**
   * init all watches
   */
  watchFields(): void {
    this.flags.enable(MassiveServiceFlags.LOAD_SERVICES_TABLE, _ => this.getValuesForFilters());

    this.watch(this.deliveriesFilters.filtersChanged).subscribe(filters => {
      this.loadServices(filters);
    });

    this.watch(this.flags.valueChanges(MassiveServiceFlags.UPLOAD_FILE)).subscribe(async flag => {
      if ( flag?.value ) {
        this.uploadFile(flag);
      }
    });

    this.watch(this.flags.valueChanges(MassiveServiceFlags.FILE_LOADED)).subscribe(async flag => {
      this.fileLoaded = flag?.value;      
    });

    this.watch(this.flags.valueChanges(MassiveServiceFlags.CREATE_SERVICES)).subscribe(async flag => {
      if (!flag?.value) {
        return environment.guardClause;
      }
      if (!this.deliveriesDataList || !this.deliveriesDataList.allowRoute || !this.idsServicesSelection) {
        return environment.guardClause;
      }
      this.flags.disable(MassiveServiceFlags.CREATE_SERVICES);
      this.router.navigate(
        ['masivos/new-create'], 
        { 
          state: 
          MuRouteDeliveriesData({
            breadcrumb: '',
            country: this.selectedCountry, 
            city: this.selectedCity, 
            company: this.selectedCompany, 
            cedi: this.selectedCedi,
            services: this.idsServicesSelection
          })
        }
      );
    });
    this.deliveriesActions.on(TableEditingActionsTypes.SAVE_ROW_EDITING, async (_, value) => {
      
      this.deliveriesDataList.allowRoute = false;
      const rowEditor = value as TableRowEditor<Service>;
      const rowService = this.deliveriesDataList.values[rowEditor.index];
      const initialRowService = this.initialValuesDeliveriesDataList[rowEditor.index];

      if ( rowService.lat === initialRowService.lat && rowService.lng === initialRowService.lng && 
            rowService.address === initialRowService.address && rowService.clientName === initialRowService.clientName && 
              rowService.idClient === initialRowService.idClient && rowService.orderId === initialRowService.orderId ) {
                rowEditor.cancel();
                rowEditor.end();
                return environment.guardClause;
              }

      
      const rowStatus = await this.massiveService.updateMassiveDeliveries(
        this.deliveriesDataList.values[rowEditor.index],
        this.selectedCountry.geoName,
        this.selectedCity.geoName,
      );
      this.deliveriesDataList.allowRoute = !rowStatus?.getIswrongaddress();
      this.deliveriesDataList.allowRoute = false;
      rowEditor.save();
      rowEditor.end();
      this.deliveriesFilters.emitFilterChanges();
    });

    this.deliveriesActions.on(TableEditingActionsTypes.CANCEL_ROW_EDITING, (_, value) => {
      const rowEditor = value as TableRowEditor<Service>;
      rowEditor.cancel();
      rowEditor.end();
    });
  }

  /**
   * init form for massive selection
   */
  initForm(): void {
    this.formData = this.formBuilder.group({
      selectedServices: [],
      unselectedServices: [],
    });

    const selectedServices = this.formData.get('selectedServices');
    const unselectedServices = this.formData.get('unselectedServices');
    selectedServices?.setValue(
      this.deliveriesDataList?.values
        .filter(x => x.check)
        .map(x => {
          return x.idClient;
        })
    );
    selectedServices?.setValue(selectedServices?.value || []);
    unselectedServices?.setValue(unselectedServices?.value || []);
  }

  /**
   * init fileForm data
   * @return void
   */
  initFileForm(): void {
    this.fileFormData = this.formBuilder.group({
      file: new UntypedFormControl('', []),
    });
  }

  /**
   * concat lat and lng
   */
  getLatLng(service: Service): string {
    return `${service.lat} / ${service.lng}`;
  }

  /**
   * get Row Index
   */
  getRowIndex(service: Service): number {
    const { limit, page } = this.deliveriesFilters.filterData;
    const realPage = page - 1;
    return limit * realPage + service.muIndex + 1;
  }

  /**
   * Load an excel file and create the service's stops
   */
  async buildStreamingForUploadFile(): Promise<any> {
    let file = this.fileFormData.get('file').value;
    const fileId = await this.massiveService.uploadExcelFile(uuidv4(), file);
    const request = new CreateMassiveDeliveryNewRequest();
    request.setCedipointid(this.selectedCedi.id);
    request.setCityid(this.selectedCity.id);
    request.setCityname(this.selectedCity.geoName);
    request.setCompanyid(this.selectedCompany.id);
    request.setCountry(this.selectedCountry.iso2);
    request.setFileid(fileId);
    return this.mdClient.createMassiveDelivery(request);
  }

  /**
   * Load an excel file and create the service's stops
   */
  async uploadFile(flag: FlagChangedValue): Promise<void> {
    const streaming = await this.buildStreamingForUploadFile();
    if (typeof streaming?.on !== 'function') {
      return environment.guardClause;
    }
    streaming.on('data', data => {
      switch (data?.getStatus()) {
        case 'END': {
          this.deliveriesFilters.emitFilterChanges();
          this.hideModals();
          flag.toggle();
          return environment.guardClause;
        }
        case 'ERROR': {
          const msg = data?.getMessage();
          this.showErrorModal( msg || this.translateService.instant('context.massive.processingExcel.genericErrorMessage'));
          return environment.guardClause;
        }
      }
    });
    streaming.on('error', _ => {
      this.showErrorModal(this.translateService.instant('context.massive.processingExcel.genericErrorMessage'));
    });
  }

  /**
   * get the services of a request
   */
  loadServices(filters: DeliveriesFilters): void {
    this.deliveriesDataList = null;
    this.initialValuesDeliveriesDataList = null;
    this.flags.execute(MassiveServiceFlags.LOAD_SERVICES_TABLE, async test => {
      if (test()) {
        filters.nameLocalities = [];
        filters?.idLocalities?.forEach( id => {
          const locality = this.localityList.find(item => item.value === parseInt(id) );
          filters.nameLocalities.push(locality.label);
        });
        this.deliveriesDataList = await this.massiveService.listMassiveDeliveries(this.selectedCompany.id, this.selectedCedi.id, filters);
        this.initialValuesDeliveriesDataList = this.deliveriesDataList?.values.map( (svc: Service) => {
          return { 
            orderId: svc.orderId,
            idClient: svc.idClient,
            clientName: svc.clientName,
            address: svc.address,
            lng: svc.lng,
            lat: svc.lat,
          }
        });
        this.initForm();
      }
    });
  }

  
  /**
   * Method used to get values for the table filters
   */
  async getValuesForFilters(): Promise<void> {
    this.localityList = [];
    (await this.massiveService.getLocalities(this.selectedCity.id))?.forEach( locality => {
      if ( locality.getActive() ) {
        this.localityList.push( {
          value: locality.getId(),
          label: locality.getName()
        });
      }
    });
    this.sizeList = [];
    (await this.massiveService.getListSizes())?.forEach( size => {
      if ( size.getActive() ) {
        this.sizeList.push( {
          value: size.getCodesize(),
          label: size.getNamesize()
        });
      }
    });
  }

  /**
   * Remove markers from map
   */
  muOnDestroy(): void {
    this.markers = [];
  }

  /**
   * Save services selection from Table
   *
   * @param services services from table multi-selection
   */
  servicesSelection(services: Service[]): void {
    this.markers = [];
    this.idsServicesSelection = [];
    const url = sameNextDayConstants.markerIconsStructure.path + 'warehouse' + sameNextDayConstants.markerIconsStructure.extension;
    const scaledSize = new google.maps.Size(sameNextDayConstants.mapOptions.commonMarkerWidth, sameNextDayConstants.mapOptions.commonMarkerHeight)
    services.forEach( service => {
      this.idsServicesSelection.push( service.mdDeliveryPkgId );
      const markerOptionPosition: MarkerOptionPositionShared = {
        lat: parseFloat(service.lat),
        lng: parseFloat(service.lng),
      };
      this.markers.push(
        new google.maps.Marker({
          position: markerOptionPosition,
          icon: { url, scaledSize },
          zIndex: 100,
        })
      );
    });
  }

  /**
   * Closes file form data
   * @param fileUploadform 
   * @return void
   */
  cancelFileForm(fileUploadform: any): void  {
    this.flags.disable(MassiveServiceFlags.LOAD_SERVICES_TABLE);
    if (fileUploadform.fileControl) {
      fileUploadform.fileControl.clear();
    }
    fileUploadform.fileUploaded = false;
    this.fileLoaded = false;
    this.flags.disable(MassiveServiceFlags.FILE_LOADED);
  }

  /**
  * Hides the displayed modals from the view. 
  * @return void
  */
  hideModals(): void  {
    this.flags.disable(MassiveServiceFlags.SHOW_LOAD_FILE);
  }
  
  /**
   * Show error modal with error message
   * @param errorMessage 
   * @return void
   */
  showErrorModal(errorMessage: string): void  {
    this.errorMessage = errorMessage;
    this.hideModals();
    this.flags.enable(MassiveServiceFlags.SHOW_ERROR_MODAL);
  }
}
